<template>
  <button
    type="button"
    :class="className"
    @click="copyBookingPortalURLHandler"
    :title="title"
  >
    <i class="fas fa-copy"></i>
    {{ title }}
  </button>
</template>
<script>
import Swal from "sweetalert2";

export default {
  props: {
    className: {
      type: String,
      default: "btn btn-black",
    },
    providerId: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: "Copy Booking Portal URL",
    },
  },
  data() {
    return {
      bookingPortalRoute: "/booking",
    };
  },
  methods: {
    copyBookingPortalURLHandler() {
      let url = `${window.location.origin}${this.bookingPortalRoute}`;
      if (this.providerId) {
        url = `${url}/${this.providerId}`;
      }
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      });
      navigator.clipboard.writeText(url).then(
        () => {
          Toast.fire({
            icon: "success",
            title: this.providerId
              ? `${this.$providerLabel({
                  type: "singular",
                  capitalize: true,
                })} Booking Portal URL copied to clipboard`
              : "Booking Portal URL copied to clipboard",
          });
        },
        () => {
          Toast.fire({
            icon: "error",
            title: "Failed to copy URL",
          });
        }
      );
    },
  },
};
</script>
<style lang=""></style>
